import { Link, useParams } from 'react-router-dom';

import { EventLineup } from '../pages/organizer/EventLineup';
import { usePageChrome } from './pageChrome';
import { useEventPaths } from './routeBase';

/**
 * The lineup section as its own addressable page.
 *
 * ── AN ADAPTER, NOT A SECOND LINEUP ──────────────────────────────────────────────────
 *
 * EventLineup takes an eventId prop and is rendered inline by EventManage. It has no
 * opinion about routing, which is exactly the shell-neutral shape §6 asks for — so making
 * it deep-linkable needs a route adapter that reads the param and nothing else. There is
 * no admin copy of the lineup, and EventManage still renders the same component inline.
 */
export function EventLineupRoute() {
  const { eventId } = useParams();
  const paths = useEventPaths();

  usePageChrome({ title: 'Lineup' });

  if (!eventId) return null;

  return (
    <div className="org-page">
      <p className="org-breadcrumb">
        <Link to={paths.manage(eventId)}>← Back to the event</Link>
      </p>
      <EventLineup eventId={eventId} />
    </div>
  );
}
